import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export const LANGUAGES = {
  UK: 'uk',
  EN: 'en',
};

export const UI_LANGUAGES = [
  { name: LANGUAGES.UK, titleKey: 'languages.uk' },
  { name: LANGUAGES.EN, titleKey: 'languages.en' },
];

export const UI_LANGUAGE_STORAGE_KEY = 'ui-language';

export const INIT_UI_LANGUAGE = cookies.get(UI_LANGUAGE_STORAGE_KEY) || LANGUAGES.UK;

// Should be used for ONLY Volia API calls
export const getCurrentLangVoliaAPICode = () => {
  const LANGUAGES_MAP = {
    uk: 'UA',
    // legacy value
    ua: 'UA',
    en: 'EN',
  };

  return LANGUAGES_MAP[INIT_UI_LANGUAGE];
};
